import React, { Component } from 'react'
import Spinner from 'react-spinner-material'
import { HorizontalBar } from 'react-chartjs-2'
import { HistoryService } from '../../app/historyService'

const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    layout: {
        padding: {
            left: 10,
            right: 20,
            top: 10,
            bottom: 10
        }
    },
    scales: {
        xAxes: [{
            stacked: true,
            gridLines: {
                display: true,
                color: 'rgba(0, 0, 0, 0.05)',
                drawBorder: false
            },
            ticks: {
                beginAtZero: true,
                fontColor: '#6B7280',
                fontSize: 10
            }
        }],
        yAxes: [{
            stacked: true,
            gridLines: {
                display: false
            },
            ticks: {
                fontColor: '#374151',
                fontSize: 11,
                padding: 10,
                callback: function (value) {
                    if (value.length > 25) {
                        return value.substr(0, 25) + '...';
                    }
                    return value;
                }
            },
            barPercentage: 0.7,
            categoryPercentage: 0.8
        }]
    },
    tooltips: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)',
        titleFontSize: 13,
        bodyFontSize: 12,
        xPadding: 12,
        yPadding: 10,
        cornerRadius: 8,
        callbacks: {
            title: function (tooltipItem, data) {
                return data.labels[tooltipItem[0].index];
            }
        }
    },
    onClick: (event, elements) => {
        if (elements[0] !== undefined) {
            const chart = elements[0]._chart;
            const element = chart.getElementAtEvent(event)[0];
            const xLabel = chart.data.labels[element._index];
            const xLabelStatus = chart.data.datasets[element._datasetIndex].label
            HistoryService.sendData('/inspections', { categoryData: xLabel, categoryDataStatus: xLabelStatus })
        }
    }
}

// Color pattern from TopProductsChart
const baseColors = [
    '#3B82F6', // Blue
    '#6366F1', // Indigo
    '#8B5CF6', // Purple
    '#A855F7', // Violet
    '#C084FC', // Light Purple
];

export class CategoryChart extends Component {

    render() {
        const { data: categoryData, language: currentLanguage } = this.props;

        if (!categoryData) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%'
                }}>
                    <Spinner size={50} spinnerColor="#2CA8FF" spinnerWidth={2} visible={true} />
                </div>
            );
        }

        if (categoryData.length === 0) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    color: '#9CA3AF',
                    fontSize: '14px'
                }}>
                    Sem dados
                </div>
            );
        }

        // 1. Process data: Filter, Sort, Limit
        const uniqueNames = [...new Set(categoryData.map(d => d.name))];

        const processed = uniqueNames.map(name => {
            const items = categoryData.filter(d => d.name === name);
            const valid = items
                .filter(d => d.answer === 'YES' || d.answer === 'NA' || d.answer === 'OK')
                .reduce((sum, d) => sum + d.qtt, 0);

            const improper = items
                .filter(d => d.answer === 'NO' || d.answer === 'NOK')
                .reduce((sum, d) => sum + d.qtt, 0);

            return { name, valid, improper, total: valid + improper };
        })
            .filter(p => p.total > 0)
            .sort((a, b) => b.total - a.total)
            .slice(0, 15); // Show top 15 to fill space vertically in the horizontal layout

        if (processed.length === 0) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    color: '#9CA3AF',
                    fontSize: '14px'
                }}>
                    Sem dados (inspeções {'>'} 0)
                </div>
            );
        }

        const labels = processed.map(p => p.name);
        const validData = processed.map(p => p.valid);
        const invalidData = processed.map(p => p.improper);

        // Map colors (gradient)
        const colors = labels.map((_, index) => baseColors[index % baseColors.length]);

        const dataChart = {
            labels,
            datasets: [
                {
                    label: currentLanguage.valid || 'Conforme',
                    data: validData,
                    backgroundColor: colors,
                    hoverBackgroundColor: colors.map(c => c + 'CC'),
                    borderWidth: 0,
                    borderRadius: 4
                },
                {
                    label: currentLanguage.improper || 'Não Conforme',
                    data: invalidData,
                    backgroundColor: '#EF4444',
                    hoverBackgroundColor: '#DC2626'
                }
            ]
        };

        // Calculate dynamic height to ensure it "occupies everything" vertically like the employee chart
        const dynamicHeight = Math.max(300, processed.length * 40);

        return (
            <div style={{ height: `${dynamicHeight}px`, width: '100%' }}>
                <HorizontalBar
                    data={dataChart}
                    options={options}
                />
            </div>
        );
    }
}
